import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import { useVipStore } from "../context/VipContext";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export default function VipSidebar() {
  const navigate = useNavigate();
  const { selectedVip } = useVipStore();
  const vipId = selectedVip?._id || selectedVip?.id;

  const [unreadCount, setUnreadCount] = useState(0);

  const fetchUnreadCount = async () => {
    if (!vipId) return;

    try {
      const token = localStorage.getItem("vipToken");
      const res = await axios.get(
        `${BASE_URL}/api/notification/vip/${vipId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const unread = Array.isArray(res.data)
        ? res.data.filter((n) => !n.read).length
        : 0;

      setUnreadCount(unread);
    } catch (err) {
      console.error("VIP Sidebar count error:", err);
    }
  };

  useEffect(() => {
    fetchUnreadCount();
  }, [vipId]);

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/login");
  };

  return (
    <>
      {/* Modern Animated & Attractive Styles */}
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

          .vip-sidebar {
            width: 280px;
            min-width: 280px;
            height: 100vh;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            background-size: 400% 400%;
            animation: gradientShift 12s ease infinite;
            border-right: 1px solid rgba(255, 255, 255, 0.15);
            box-shadow: 8px 0 30px rgba(0, 0, 0, 0.2);
            padding: 30px 0;
            position: fixed;
            top: 0;
            left: 0;
            overflow-y: auto;
            font-family: 'Inter', sans-serif;
            transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
            z-index: 1000;
          }

          /* ✅ HIDE SIDEBAR ON ≤991px */
          @media (max-width: 991px) {
            .vip-sidebar {
              display: none !important;
            }
          }

          @keyframes gradientShift {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }

          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .vip-sidebar::before {
            content: '';
            position: absolute;
            top: 0; left: 0; right: 0; bottom: 0;
            background: linear-gradient(180deg, rgba(255,255,255,0.12) 0%, transparent 50%);
            pointer-events: none;
          }

          // @media (max-width: 1024px) {
          //   .vip-sidebar {
          //     width: 90px;
          //     min-width: 90px;
          //   }
          //   .vip-sidebar .logo-text,
          //   .vip-sidebar .menu-text,
          //   .vip-sidebar .section-title {
          //     opacity: 0;
          //     visibility: hidden;
          //     width: 0;
          //     overflow: hidden;
          //     transition: all 0.3s ease;
          //   }
          //   .vip-sidebar .menu-link {
          //     justify-content: center;
          //     padding: 16px;
          //   }
          //   .vip-sidebar .icon {
          //     font-size: 22px;
          //   }
          //   .vip-sidebar .badge {
          //     top: -10px;
          //     right: -10px;
          //     font-size: 10px;
          //     padding: 4px 7px;
          //   }
          // }

          .logo-box {
            text-align: center;
            margin-bottom: 50px;
            padding: 0 28px;
            animation: fadeInUp 0.8s ease-out;
          }

          .logo-link {
            display: inline-block;
            padding: 18px 28px;
            background: rgba(255, 255, 255, 0.2);
            backdrop-filter: blur(10px);
            border: 1px solid rgba(255, 255, 255, 0.3);
            border-radius: 20px;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
            transition: all 0.4s ease;
          }

          .logo-link:hover {
            transform: translateY(-6px) scale(1.05);
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
            background: rgba(255, 255, 255, 0.3);
          }

          .logo-text {
            font-size: 28px;
            font-weight: 800;
            color: #ffffff;
            letter-spacing: 1px;
            text-shadow: 0 2px 10px rgba(0,0,0,0.3);
          }

          .menu-wrapper {
            padding: 0 28px;
          }

          .menu-list {
            list-style: none;
            padding: 0;
            margin: 0;
          }

          .section-title {
            font-size: 13px;
            font-weight: 700;
            color: rgba(255, 255, 255, 0.8);
            text-transform: uppercase;
            letter-spacing: 2px;
            margin: 40px 0 16px 16px;
            opacity: 0.9;
            animation: fadeInUp 0.8s ease-out;
          }

          .menu-item {
            margin-bottom: 8px;
            animation: fadeInUp 0.6s ease-out;
            animation-fill-mode: both;
          }

          .menu-link {
            display: flex;
            align-items: center;
            gap: 18px;
            padding: 16px 20px;
            border-radius: 16px;
            text-decoration: none;
            font-size: 16px;
            font-weight: 600;
            color: #ffffff;
            background: rgba(255, 255, 255, 0.1);
            backdrop-filter: blur(10px);
            border: 1px solid rgba(255, 255, 255, 0.15);
            transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
            position: relative;
            overflow: hidden;
          }

          .menu-link::before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            width: 5px;
            background: #ffffff;
            transform: scaleY(0);
            transition: transform 0.4s ease;
          }

          .menu-link:hover {
            background: rgba(255, 255, 255, 0.25);
            transform: translateX(8px);
            box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
          }

          .menu-link:hover::before {
            transform: scaleY(1);
          }

          .menu-link.active {
            background: rgba(255, 255, 255, 0.3);
            color: #ffffff;
            font-weight: 700;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
          }

          .menu-link.active::before {
            transform: scaleY(1);
          }

          .icon {
            font-size: 20px;
            width: 28px;
            text-align: center;
            transition: all 0.3s ease;
            filter: drop-shadow(0 2px 4px rgba(0,0,0,0.2));
          }

          .menu-link:hover .icon {
            transform: scale(1.15);
          }

          .menu-text {
            transition: opacity 0.3s ease;
            white-space: nowrap;
          }

          .badge {
            position: absolute;
            top: -10px;
            right: -10px;
            background: #ff3b30;
            color: #fff;
            border-radius: 50%;
            font-size: 12px;
            font-weight: 700;
            min-width: 24px;
            height: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 4px 12px rgba(255, 59, 48, 0.5);
            animation: pulse 2s infinite;
          }

          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.1); }
            100% { transform: scale(1); }
          }

          .logout-btn {
            margin-top: 30px;
            border-top: 1px solid rgba(255, 255, 255, 0.2);
            padding-top: 30px;
          }

          .logout-btn .menu-link {
            color: #ff6b6b;
            border: 1px solid rgba(255, 107, 107, 0.3);
          }

          .logout-btn .menu-link:hover {
            background: rgba(255, 107, 107, 0.25);
            color: #ff5252;
            transform: translateX(8px);
          }

          .logout-btn .icon {
            color: #ff6b6b;
          }

          /* Scrollbar */
          .vip-sidebar::-webkit-scrollbar {
            width: 6px;
          }

          .vip-sidebar::-webkit-scrollbar-thumb {
            background: rgba(255, 255, 255, 0.3);
            border-radius: 3px;
          }
        `}
      </style>

      <div className="vip-sidebar">
        <div className="logo-box">
          <NavLink to="/vipdashboard" className="logo-link">
            <span className="logo-text">VIP Panel</span>
          </NavLink>
        </div>

        <div className="menu-wrapper">
          <ul className="menu-list">
            <li className="menu-item">
              <NavLink
                to="/vipdashboard"
                className={({ isActive }) => `menu-link ${isActive ? "active" : ""}`}
                end
              >
                <i className="fas fa-home icon"></i>
                <span className="menu-text">Dashboard</span>
              </NavLink>
            </li>

            <li className="section-title">Manage</li>

            <li className="menu-item">
              <NavLink
                to="/assignofficers"
                className={({ isActive }) => `menu-link ${isActive ? "active" : ""}`}
              >
                <i className="fas fa-user-shield icon"></i>
                <span className="menu-text">Assigned Officers</span>
              </NavLink>
            </li>

            <li className="menu-item">
              <NavLink
                to="/viphistory"
                className={({ isActive }) => `menu-link ${isActive ? "active" : ""}`}
              >
                <i className="fas fa-history icon"></i>
                <span className="menu-text">Officer Duty History</span>
              </NavLink>
            </li>

            <li className="menu-item">
              <NavLink
                to="/vipNotification"
                className={({ isActive }) => `menu-link ${isActive ? "active" : ""}`}
              >
                <div style={{ position: "relative" }}>
                  <i className="fas fa-bell icon"></i>
                  {unreadCount > 0 && (
                    <span className="badge">{unreadCount > 99 ? "99+" : unreadCount}</span>
                  )}
                </div>
                <span className="menu-text">Notifications</span>
              </NavLink>
            </li>

            <li className="menu-item">
              <NavLink
                to="/vipfeedbacks"
                className={({ isActive }) => `menu-link ${isActive ? "active" : ""}`}
              >
                <i className="fas fa-comment-dots icon"></i>
                <span className="menu-text">Feedbacks</span>
              </NavLink>
            </li>
            
            <li className="menu-item">
              <NavLink
                to="/vipduty"
                className={({ isActive }) => `menu-link ${isActive ? "active" : ""}`}
              >
                <i className="fas fa-tasks icon"></i>
                <span className="menu-text">Duty Management</span>
              </NavLink>
            </li>

             <li className="menu-item">
              <NavLink
                to="/vipcomplaints"
                className={({ isActive }) => `menu-link ${isActive ? "active" : ""}`}
              >
                <i className="fas fa-flag icon"></i>
                <span className="menu-text">Complaints</span>
              </NavLink>
            </li> 


            <li className="menu-item">
              <NavLink
                to="/vipprofile"
                className={({ isActive }) => `menu-link ${isActive ? "active" : ""}`}
              >
                <i className="fas fa-user icon"></i>
                <span className="menu-text">My Profile</span>
              </NavLink>
            </li>

            <li className="menu-item logout-btn">
              <button
                className="menu-link"
                style={{ border: "none", background: "none", width: "100%", textAlign: "left", cursor: "pointer" }}
                onClick={handleLogout}
              >
                <i className="fas fa-sign-out-alt icon"></i>
                <span className="menu-text">Logout</span>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}

// import React, { useEffect, useState } from "react";
// import { NavLink, useNavigate } from "react-router-dom";
// import axios from "axios";
// import { useVipStore } from "../context/VipContext";

// const BASE_URL = process.env.REACT_APP_BASE_URL;

// export default function VipSidebar() {
//   const navigate = useNavigate();
//   const { selectedVip } = useVipStore();
//   const vipId = selectedVip?._id || selectedVip?.id;

//   const [unreadCount, setUnreadCount] = useState(0);

//   const fetchUnreadCount = async () => {
//     if (!vipId) return;

//     try {
//       const token = localStorage.getItem("vipToken");

//       const res = await axios.get(
//         `${BASE_URL}/api/notification/vip/${vipId}`,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       const unread = Array.isArray(res.data)
//         ? res.data.filter((n) => !n.read).length
//         : 0;

//       setUnreadCount(unread);
//     } catch (err) {
//       console.error("VIP Sidebar count error:", err);
//     }
//   };

//   /* ✅ ONLY FETCH ON VIP CHANGE — NO TIMER */
//   useEffect(() => {
//     fetchUnreadCount();
//   }, [vipId]);

//   const handleLogout = () => {
//     localStorage.clear();
//     sessionStorage.clear();
//     navigate("/login");
//   };

//   return (
//     <>
//       {/* SAME HOVER EFFECT — UNCHANGED */}
//       <style>
//         {`
//           .menu-link {
//             background: linear-gradient(
//               to right,
//               rgba(173, 216, 230, 0.45) 50%,
//               transparent 50%
//             );
//             background-size: 200% 100%;
//             background-position: right bottom;
//             transition: background-position 0.25s ease;
//           }

//           .menu-link:hover {
//             background-position: left bottom;
//             color: #1e73be;
//           }
//         `}
//       </style>

//       <div style={styles.sidebarContainer} className="sidebar">
//         <div style={styles.logoBox}>
//           <NavLink to="/vipdashboard" style={styles.logoLink}>
//             <span style={styles.logoText}>VIP Panel</span>
//           </NavLink>
//         </div>

//         <div style={styles.menuWrapper}>
//           <ul style={styles.menuList}>

//             <li style={styles.menuItem}>
//               <NavLink
//                 to="/vipdashboard"
//                 style={styles.menuLink}
//                 className="menu-link mt-3"
//               >
//                 <i className="fas fa-home" style={styles.icon}></i>
//                 <span>Dashboard</span>
//               </NavLink>
//             </li>

//             <li style={styles.sectionTitle}>Manage</li>

//             <li style={styles.menuItem}>
//               <NavLink
//                 to="/assignofficers"
//                 style={styles.menuLink}
//                 className="menu-link"
//               >
//                 <i className="fas fa-user-shield" style={styles.icon}></i>
//                 <span>Assigned Officers</span>
//               </NavLink>
//             </li>

//             <li style={styles.menuItem}>
//               <NavLink
//                 to="/viphistory"
//                 style={styles.menuLink}
//                 className="menu-link"
//               >
//                 <i className="fas fa-history" style={styles.icon}></i>
//                 <span>Officer Duty History</span>
//               </NavLink>
//             </li>

//             <li style={styles.menuItem}>
//               <NavLink
//                 to="/vipNotification"
//                 style={styles.menuLink}
//                 className="menu-link"
//               >
//                 <div style={{ position: "relative" }}>
//                   <i className="fas fa-bell" style={styles.icon}></i>
//                   {unreadCount > 0 && (
//                     <span style={styles.badge}>{unreadCount}</span>
//                   )}
//                 </div>
//                 <span>Notifications</span>
//               </NavLink>
//             </li>

//             <li style={styles.menuItem}>
//               <NavLink
//                 to="/vipcomplaints"
//                 style={styles.menuLink}
//                 className="menu-link"
//               >
//                 <i className="fas fa-flag" style={styles.icon}></i>
//                 <span>Complaints</span>
//               </NavLink>
//             </li>

//             <li style={styles.menuItem}>
//               <NavLink
//                 to="/vipfeedbacks"
//                 style={styles.menuLink}
//                 className="menu-link"
//               >
//                 <i className="fas fa-comment-dots" style={styles.icon}></i>
//                 <span>Feedbacks</span>
//               </NavLink>
//             </li>

//             <li style={styles.menuItem}>
//               <NavLink
//                 to="/vipduty"
//                 style={styles.menuLink}
//                 className="menu-link"
//               >
//                 <i className="fas fa-tasks" style={styles.icon}></i>
//                 <span>Duty Management</span>
//               </NavLink>
//             </li>

//             <li style={styles.menuItem}>
//               <NavLink
//                 to="/vipprofile"
//                 style={styles.menuLink}
//                 className="menu-link"
//               >
//                 <i className="fas fa-user" style={styles.icon}></i>
//                 <span>My Profile</span>
//               </NavLink>
//             </li>

//             <li>
//               <button
//                 className="menu-link"
//                 style={{ ...styles.menuLink, border: "none", background: "none" }}
//                 onClick={handleLogout}
//               >
//                 <i className="fas fa-sign-out-alt" style={styles.icon}></i>
//                 <span>Logout</span>
//               </button>
//             </li>

//           </ul>
//         </div>
//       </div>
//     </>
//   );
// }

// /* ✅ STYLES — UNCHANGED */
// const styles = {
//   sidebarContainer: {
//     width: "260px",
//     height: "100vh",
//     background: "rgba(255, 255, 255, 0.28)",
//     backdropFilter: "blur(10px)",
//     borderRight: "1px solid rgba(255,255,255,0.3)",
//     boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
//     paddingTop: "20px",
//     position: "fixed",
//     top: 0,
//     left: 0,
//     overflowY: "auto",
//   },

//   logoBox: {
//     textAlign: "center",
//     marginBottom: "35px",
//     padding: "18px 0",
//     background: "linear-gradient(135deg, #4e54c8, #8f94fb)",
//     borderRadius: "14px",
//     width: "85%",
//     margin: "auto",
//   },

//   logoLink: { textDecoration: "none" },

//   logoText: {
//     fontSize: "26px",
//     fontWeight: "700",
//     color: "#fff",
//   },

//   menuWrapper: { padding: "0 20px" },
//   menuList: { listStyle: "none", padding: 0, margin: 0 },
//   menuItem: { marginBottom: "10px" },

//   menuLink: {
//     display: "flex",
//     alignItems: "center",
//     gap: "12px",
//     padding: "12px 15px",
//     borderRadius: "10px",
//     textDecoration: "none",
//     fontSize: "15px",
//     fontWeight: "600",
//     color: "#1e1e1e",
//   },

//   icon: { fontSize: "18px", color: "#1e73be" },

//   sectionTitle: {
//     fontSize: "13px",
//     fontWeight: "700",
//     color: "#1e73be",
//     margin: "20px 0 10px 10px",
//     textTransform: "uppercase",
//   },

//   badge: {
//     position: "absolute",
//     top: "-6px",
//     right: "-10px",
//     background: "red",
//     color: "#fff",
//     borderRadius: "50%",
//     fontSize: "11px",
//     padding: "2px 7px",
//     fontWeight: "700",
//   },
// };
